import React from 'react'

import styles from './styles.module.scss'

interface IDealerPhone {
  name: string,
  phone?: string,
  notProvidedName?: string
}

export default function DealerPhone({name, phone, notProvidedName}: IDealerPhone) {
  if (!!phone) {
    return (
      <>
        <p className={styles.dealershipText}>
          { name }
        </p>
        <h2 className={styles.dealershipNumber}>
           Phone number: <a href={`tel:${phone}`}>{ phone }</a>
        </h2>
      </>
    )
  }
  
  return <p>{notProvidedName ? notProvidedName : name} did not provide contact details</p>
}